import React from 'react'
import Lottie from 'react-lottie'
import * as animationData from '../../../resources/animations/glow_loading.json'

import './style.css'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}
const Loading = () => {
  return <div className='loader'>
    <Lottie options={defaultOptions} height={300} width={300} />
    <i className='center-vertically'><h3>Kenetto</h3></i>
  </div>
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/common/Loading/Loading.js